import React, { useState, useEffect } from "react";
import { CLIENT_REVIEW } from "../../data/data";
import useMediaQuery from "../../hooks/useMediaQuery";
import { useLocation } from "react-router-dom";

const ClientReviewPanel = () => {
  const [selectedClient, setSelectedClient] = useState(CLIENT_REVIEW[0]);

  const isDesktop = useMediaQuery("(min-width: 767px)");

  const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(
                location.hash.replace("#", "")
            );
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

  return (
    <section className="bg-gray-50 dark:bg-[#0F172A] container" id="client-review">
      <div className="container mx-auto px-4 flex flex-col md:flex-row gap-6">
        {/* Left: Client Cards */}
        <div className="flex md:flex-col md:gap-3 gap-1  md:w-1/4 overflow-x-auto md:overflow-visible">
          {CLIENT_REVIEW.map((client) => (
            <div
              key={client.id}
              onClick={() => setSelectedClient(client)}
              className={`cursor-pointer flex flex-col items-center bg-white dark:bg-slate-900 rounded-xl border shadow-md hover:shadow-lg transition md:p-2 min-w-[70px] md:min-w-full ${selectedClient.id === client.id ? "ring-2 ring-green-500" : ""
                }`}
            >
              <img
                src={client.profile}
                alt={client.name}
                className="w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-green-200 dark:border-green-600 object-cover mb-1"
              />
              <h4 className="text-xs md:text-sm md:font-semibold text-slate-800 dark:text-white text-center">
                {client?.name}
              </h4>
              {
                isDesktop && <p className="text-[10px] md:text-xs text-slate-500 dark:text-slate-400 text-center">
                {client.designation}
              </p>
              }
              
            </div>
          ))}
        </div>

        {/* Right: Selected Client Review */}
        <div className="md:w-3/4 bg-white dark:bg-slate-900 rounded-3xl shadow-xl p-8 md:p-12 flex flex-col justify-center transition-all duration-500 relative border">
          {/* Decorative Quote */}
          <span className="absolute -top-6 left-6 text-6xl text-green-100 dark:text-green-800 opacity-30 select-none">
            “
          </span>

          {/* Profile */}
          <div className="flex items-center gap-6 mb-6">
            <img
              src={selectedClient.profile}
              alt={selectedClient.name}
              className="w-28 h-28 md:w-36 md:h-36 rounded-full border-4 border-green-200 dark:border-green-600 object-cover"
            />
            <div>
              <h4 className="text-xl md:text-2xl font-bold text-slate-800 dark:text-white">
                {selectedClient.name}
              </h4>
              
              <p className="text-slate-500 dark:text-slate-300 max-w-xl mx-auto">
                {selectedClient.designation}
              </p>
            </div>
          </div>

          {/* Title */}
          {selectedClient.title && (
            <p className="text-lg md:text-xl font-semibold text-slate-700 dark:text-slate-200 mb-4">
              {selectedClient.title}
            </p>
          )}

          {/* Description */}
          <p className="text-base md:text-lg text-slate-600 dark:text-slate-300 leading-relaxed">
            {selectedClient.description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ClientReviewPanel;
